import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Home as HomeIcon,
  Business as ServicesIcon,
  CalendarToday as BookingIcon,
  ContactMail as ContactIcon,
  AutoAwesome as KundaliIcon,
  VideoCall as VideoIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  WbSunny as RashiIcon,
  Favorite as MatchingIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';
import { useAdmin } from '../../contexts/AdminContext';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { isAdmin } = useAdmin();

  const navItems = [
    { path: '/', label: 'Home', icon: <HomeIcon /> },
    { path: '/services', label: 'Services', icon: <ServicesIcon /> },
    { path: '/kundali', label: 'Kundali', icon: <KundaliIcon /> },
    { path: '/kundali-matching', label: 'Matching', icon: <MatchingIcon /> },
    { path: '/rashi-phal', label: 'Rashi Phal', icon: <RashiIcon /> },
    { path: '/book-slot', label: 'Book Slot', icon: <BookingIcon /> },
    { path: '/contact', label: 'Contact', icon: <ContactIcon /> },
    ...(isAdmin ? [{ path: '/admin', label: 'Admin', icon: <AdminIcon /> }] : []),
  ];

  const handleNav = (path: string) => {
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <>
      <AppBar position="sticky" elevation={0}>
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: 'space-between', py: 0.5, minHeight: { xs: 56, sm: 64 } }}>
            <Box
              onClick={() => navigate('/')}
              sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
            >
              <Box
                component="img"
                src="/images/Icon.png"
                alt="Amruthakalasam"
                sx={{ width: 36, height: 36, borderRadius: '8px', objectFit: 'cover' }}
              />
              <Typography
                variant="h6"
                component="div"
                sx={{ fontWeight: 700, color: 'primary.main', fontSize: { xs: '1rem', sm: '1.15rem' } }}
              >
                Amrutha Kalasam
              </Typography>
            </Box>

            {/* Desktop nav */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
              {navItems.map((item) => (
                <Button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  size="small"
                  variant={location.pathname === item.path ? 'contained' : 'text'}
                  sx={{
                    px: 2,
                    fontWeight: location.pathname === item.path ? 700 : 500,
                    color: location.pathname === item.path ? '#fff' : 'text.primary',
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>

            {/* Mobile hamburger */}
            <IconButton
              sx={{ display: { xs: 'flex', md: 'none' } }}
              onClick={() => setDrawerOpen(true)}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 260, pt: 1 } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
            Menu
          </Typography>
          <IconButton onClick={() => setDrawerOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List>
          {navItems.map((item) => (
            <ListItemButton
              key={item.path}
              onClick={() => handleNav(item.path)}
              selected={location.pathname === item.path}
              sx={{
                mx: 1,
                borderRadius: 2,
                mb: 0.5,
                '&.Mui-selected': {
                  backgroundColor: 'primary.main',
                  color: '#fff',
                  '& .MuiListItemIcon-root': { color: '#fff' },
                  '&:hover': { backgroundColor: 'primary.dark' },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
